import { render, staticRenderFns } from "./RspoApiTable.vue?vue&type=template&id=2baa2845&scoped=true"
import script from "./RspoApiTable.vue?vue&type=script&lang=js"
export * from "./RspoApiTable.vue?vue&type=script&lang=js"
import style0 from "./RspoApiTable.vue?vue&type=style&index=0&id=2baa2845&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2baa2845",
  null
  
)

export default component.exports